import type { FilterSelection } from "@interfaces/filters/domain";

export interface BrandRef {
  // Regular brands are numeric ids; brand sets are ULID strings.
  id: number | string;
  name: string;
  // "BRAND" | "BRAND_SET" — lets the agent address brand sets by their ULID.
  type: string;
}

export interface MarketRef {
  id: number;
  name: string;
}

/**
 * Filters travel as the v2 registry-code `FilterSelection` shape
 * (`{code, kind:'OPTION', options:[optCode…]}` or
 * `{code, kind:'RANGE', range:{min,max}}`), matching the analytics/segments v2
 * wire contract. The legacy `{filterId, filterOptions}` shape is retired.
 */
export type FilterRef = FilterSelection;

export interface PeriodRef {
  type: string;
  startDate?: string;
  endDate?: string;
}

export interface CurrentScreenContext {
  brands: BrandRef[];
  secondaryBrands: BrandRef[];
  markets: MarketRef[];
  module: string;
  metricKeys: Array<string | number>;
  groupKeys: Array<string | number>;
  responseKeys: Array<string | number>;
  segments: string[];
  filters: FilterRef[];
  audienceBase: string;
  viewMode: string;
  visualizationType: string;
  groupedBy: string;
  statTest: string;
  scoreType: string;
  response: string | null;
  intervalType: string;
  period: PeriodRef;
  postPeriod: PeriodRef;
}

export const DEFAULT_SCREEN_CONTEXT: CurrentScreenContext = {
  brands: [],
  secondaryBrands: [],
  markets: [],
  module: "",
  metricKeys: [],
  groupKeys: [],
  responseKeys: [],
  segments: [],
  filters: [],
  audienceBase: "GENPOP",
  viewMode: "POINT_IN_TIME",
  visualizationType: "BAR",
  groupedBy: "BRAND",
  statTest: "NONE",
  scoreType: "",
  response: null,
  intervalType: "",
  period: { type: "" },
  postPeriod: { type: "" },
};
